import * as React from 'react';
import { ReactNode } from 'react';
import { PhoneFrameWrapper, PhoneFrameContent } from './PhoneFrame.s';

export { phoneFrameSizes } from './PhoneFrame.s';

export type PhoneFrameProps = {
  scale?: number;
  children?: ReactNode;
};

export const PhoneFrame = (props: PhoneFrameProps) => (
  <PhoneFrameWrapper phoneScale={props.scale}>
    <PhoneFrameContent>
      {props.children}
    </PhoneFrameContent>
  </PhoneFrameWrapper>
);



// WEBPACK FOOTER //
// src/app/src/components/PhoneFrame/PhoneFrame.tsx